export enum FeatureFlags {
  LEAD_ANALYSIS = "lead_analysis",
  INDUSTRY_VALUE = "industry_value",
  SALES_VS_QUOTA_WIDGET = "sales_vs_quota_widget",
  DREAMER_IN_SLACK = "dreamer_in_slack",
  VERSION = "version",
  DEAL_COMMERCIALS = "deal_commercials",
  ACCOUNT_CONNECTIONS = "account_connections",
  NEW_QUICK_VIEW = "new_quick_view",
  EDIT_SERVICE_ITEM = "edit_service_item",
  PERSONAL_API_KEY = "crm-5431-personal-api-key",
  VIEW_CACHE = "crm-5534-view-cache",
  TRANSCRIPT_UPLOAD = "CRM-5772-transcript-upload",
  COMPANY_COMMERCIALS_V2 = "company_commercials_v2",
  CRM_6321_CONTRACTS = "crm-6321-contracts",
  CRM_5368_SERVICES = "crm-5368-services",
  CRM_6572_CONTRACT_ACTIVITIES_PEOPLE = "crm-6572-contract-activities-people",
  CRM_6743_STOP_GENERATING = "CRM-6743-stop-generating",
  CRM_6634_CLOSED_LOST_DREAMER = "crm-6634-closed-lost-dreamer",
  CRM_6707_DEAL_TO_CONTRACT = "crm-6707-deal-to-contract",
  CRM_6311_REPORTING_SCHEDULER = "CRM-6311-reporting-scheduler",
  CRM_6892_ONBOARDING_STUDIO = "crm-6892-onboarding-studio",
  CRM_6987_DEMO_MODE = "crm-6987-demo-mode",
  CRM_7161_EDIT_FINANCIAL_RECOGNITION = "crm-7161-edit-financial-recognition",
  CRM_6903_ONBOARDING_CONTRACT = "crm-6903-onboarding-contract",
  CRM_7447_HIDE_LICENSE_FIELDS = "CRM-7447-hide-license-fields",
  CRM_7443_SCO_AUTOFILL = "CRM-7443-sco-autofill",
  CRM_7395_AUTOFILL_TEST = "CRM-7395-autofill-test",
  CRM_7342_BROWSER_PUSH_NOTIFICATIONS = "crm-7342-browser-push-notifications",
  CRM_7462_CONTRACTS_FIELD_MANAGEMENT = "CRM-7462-contracts-field-management",
  CRM_5676_ICP = "crm-5676-icp",
  CRM_6574_TASKS_IN_CONTRACTS = "crm-6574-tasks-in-contracts",
  CRM_1433_TABLE_EXPORT = "crm-1433-table-export",
  CRM_7756_CONTRACT_KPIS = "crm-7756-contract-kpis",
  CRM_7805_PARTNERSHIPS = "crm-7805-partnerships",
  CRM_7917_PARTNERS_TABLE = "crm-7917-partners-table",
  CRM_7464_LEAD_REASON_LISTS = "crm-7464-lead-reason-lists",
  CRM_5207_SYSTEM_FIELD_DEFAULT_ENTRY = "CRM-5207-system-field-default-entry",
  CRM_5207_HIDE_FIELD = "CRM-5207-hide-field",
  CRM_8132_DREAMER_SEARCH = "CRM-8132-dreamer-search",
  CRM_8228_PARTNER_CONTACTS_TABLE = "crm-8228-partner-contacts-table",
  CRM_7174_INVITE_NOTETAKER = "crm-7174-invite-notetaker",
  CRM_8124_TRANSCRIPT_PROCESSING = "CRM-8124-transcript-processing",
  CRM_8136_MARK_COMPLETED_BUTTON = "crm-8136-mark-completed-button",
  CRM_8565_CREATE_COMPANY_WITH_DREAMER = "crm-8565-create-company-with-dreamer",
  CRM_8564_CREATE_PERSON_WITH_DREAMER = "crm-8564-create-person-with-dreamer",
  CRM_8515_CREATE_LEAD_WITH_DREAMER = "crm-8515-create-lead-with-dreamer",
  CRM_7175_COLUMN_FLEX_PERSISTENCE = "crm-7175-column-flex-persistence",
  CRM_8348_MEETING_PREP = "crm-8348-meeting-prep",
  CRM_7164_CHECKLIST_ITEM_FIELD_MGMT = "crm-7164-checklist-item-field-mgmt",
  CRM_5705_CONFIGURABLE_SYSTEM_FIELDS = "crm-5705-configurable-system-fields",
  CRM_7713_DUPLICATE_CONTRACT = "crm-7713-duplicate-contract",
  CRM_8658_CHAT_VIRTUALIZATION = "crm-8658-chat-virtualization",
  CRM_8805_TASK_MULTI_LINK = "crm-8805-task-multi-link",
  CRM_8742_DEAL_PRODUCT_SERVICES = "crm-8742-deal-product-services",
  CRM_9035_MY_TASKS_PAGE = "crm-9035-my-tasks-page",
  CRM_8911_SETTINGS_PERMISSIONS = "crm-8911-settings-permissions",
  CRM_8968_PERIOD_DRILLDOWN = "crm-8968-period-drilldown",
  CRM_9188_FILE_FIELD_MGMT = "crm-9188-file-field-mgmt",
  CRM_6980_PREVIEW_FIELDS = "crm-6980-preview-fields",
  // Epic-scoped on purpose: the Contract Amendments and Corrections epic is
  // the parent of every story in this rollout, and they share one gate rather
  // than each adding a per-story flag. So this covers more than the story that
  // introduced it — do not retire it when any single child story ships.
  CRM_9208_CONTRACT_AMENDMENTS = "crm-9208-contract-amendments",
  // Replaces crm-9136-reports-tab, which is deleted rather than reused. The
  // server contract behind the tab changed — a report is a reports_schedules
  // row, not a message lineage — so a client that has not upgraded must not be
  // reachable by the flag that would turn the old code on.
  CRM_10285_MY_REPORTS = "crm-10285-my-reports",
  // Epic-scoped: every per-integration story in the Integrations settings
  // rollout shares this gate, so do not retire it when one story ships.
  CRM_9459_INTEGRATIONS_SETTINGS = "crm-9459-integrations-settings",
  CRM_9112_ZOOMINFO_INTEGRATION = "crm-9112-zoominfo-integration",
  // Epic-scoped: every CPQ story shares this gate, so do not retire it when
  // one story ships.
  CRM_9761_CPQ = "crm-9761-cpq",
  CRM_10267_DETAILED_VIEW_SECTIONS = "crm-10267-detailed-view-sections",
  CRM_10405_APOLLO_SETTINGS = "crm-10405-apollo-settings",
  CRM_9987_KPI_BAR_V2 = "crm-9987-kpi-bar-v2",
  CRM_9279_ASSIGNMENT_EDIT_RESTRICTIONS = "crm-9279-assignment-edit-restrictions",
  CRM_10582_SERVICE_NOTES = "crm-10582-service-notes",
  CRM_10630_LEAD_TO_DEAL_SUGGESTION = "crm-10630-lead-to-deal-suggestion",
  CRM_11069_HUBSPOT_SETTINGS = "crm-11069-hubspot-settings",
  CRM_11179_WEB_FORM_SETTINGS = "crm-11179-web-form-settings",
  CRM_10479_STRIPE_CHECKOUT_SETTINGS = "crm-10479-stripe-checkout-settings",
  CRM_11054_ZOOM_RECONNECT_BANNER = "crm-11054-zoom-reconnect-banner",
  CRM_11089_PRODUCT_BUNDLES = "crm-11089-product-bundles",
  CRM_11075_CONTRACT_FX_RATES = "crm-11075-contract-fx-rates",
  // Epic-scoped: settingsapi, contractsapi and automator gate contract onboarding
  // autofill on the same flag, so do not retire it when one story ships.
  CRM_10893_CONTRACT_ONBOARDING_AUTOFILL = "crm-10893-contract-onboarding-autofill"
}

export enum UserRoles {
  ACCOUNT_EXECUTIVE_LEADER = 1,
  HEAD_OF_SALES_ORGANIZATION,
  ACCOUNT_EXECUTIVE,
  SALES_ADMIN,
  SALES_DEVELOPMENT_REPRESENTATIVE,
  SALES_DEVELOPMENT_REPRESENTATIVE_LEADER,
  MARKETING_ASSOCIATE,
  MARKETING_LEADER,
  MARKETING_ADMIN,
  HEAD_OF_MARKETING_ORGANIZATION,
  CUSTOMER_SUCCESS_MANAGER,
  CUSTOMER_SUCCESS_MANAGER_LEADER,
  FINANCE_USER,
  CUSTOMER_SUCCESS_TECHNICAL_MANAGER,
  CUSTOMER_SUCCESS_TECHNICAL_MANAGER_LEADER,
  DREAMHUB_ADMIN,
  LIMITED_VIEWER
}
